import React, { Component } from 'react';
import Button from '../../button/components/ButtonComponent';
import isMobile from 'is-mobile';
import RegisterModalComponent from "../../../../shared/registermodal/components/RegisterModalComponent";
import {Link} from "react-router-dom";
import { withTranslation } from 'react-i18next';
import {
  createBrowserHistory
} from "history";

export const history = createBrowserHistory();

const Style = require('../styles/NavbarComponent.scss');


class NavbarComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        openMenu : false,
        showRegister: false
      };
      this.openMenu = this.openMenu.bind(this);
    }

    openMenu(){
      if (isMobile()){
        this.setState({openMenu: !this.state.openMenu})
      }
    }

    back() {
        history.goBack();
    }

    render() {
        return (
          <>
            <nav className={Style.nav} id="navLanding">
                <div className={`MenuResponsive show-mb ${this.state.openMenu ? "showMenu" : ""}`} >
                    <div className="open-menu-wrapper">
                      <div className="openMenuMobile"  onClick={this.openMenu}>
                          <span />
                          <span />
                          <span />
                      </div>
                    </div>
                    <div className="logo-wrapper">
                      <img src={`${process.env.PUBLIC_URL}/images/landing/header/Logo.png`} alt="" />
                    </div>
                    <div className="login-button-wrapper">
                      <Button onClick={this.props.showLogin} text="Login" />
                    </div>
                </div>

                <div className="translate-options hd-mb">
                    <a href="https://blancfashion.com" className={this.props.t('en_us_class_active')}>EN</a><span>/</span><a href="https://blancfashion.com.br" className={this.props.t('pt_br_class_active')}>PT-BR</a>
                    {window.location.pathname !== "/" &&
                        <span className="goBack" onClick={() => this.back()}>&lt;&lt;  <span>{this.props.t('Back')}</span></span>
                    }

                </div>
                <div className={`itens ${this.state.openMenu ? "showMenu" : ""}`}>
                    <ul>
                        <li><a href="/#ourbrands">{this.props.t('Our Brands')}</a></li>
                        <li><a href="/#ourplatform">{this.props.t('navbar_item_2')}</a></li>
                        {this.props.t('lang') !== 'pt_BR' ? <li><a href="/#ourretailers">{this.props.t('Our Retailers')}</a></li>: ""}
                        <li><Link to="/whoweare">{this.props.t('Who We Are')}</Link></li>
                        <li onClick={()=> this.setState({showRegister: true})} >{this.props.t('Register')}</li>
                        <li><Button onClick={this.props.showLogin} text={this.props.t('Login')} /></li>
                    </ul>
                </div>
            </nav>
            { this.state.showRegister &&

              <RegisterModalComponent close={()=> this.setState({showRegister: false})} />
            }
          </>
        );
    }
}

export default withTranslation()(NavbarComponent);
